import { App, Model, AppRegistry, ModelRegistry } from 'core/index';
import { computed } from 'mobx';
import { clientStore } from 'apps/client/app';

export class ProjectContextModel extends Model {
  static registryName = 'ProjectContextModel';
  static ModelProps = {
    parentObj: 'ProjectModel',
  };

  @computed get canCreateAnnotation() {
    // currently unused
    return true; // stub -- currently if you can access a project you can create annotations
  }

  @computed get canCreateMessage() {
    // currently unused
    return true; // stub -- currently if you can access a project you can create messages
  }

  projectEditorOrItemOwner = createdBy => {
    const canUpdateProject = this.parentObj?.canUpdate;
    return (
      canUpdateProject || clientStore?.signedInProfile?.user?.id === createdBy
    );
  };

  /* These below methods should be @computed/@observable on the Annotation/Message objects (which currently do not exist) */

  canUpdateAnnotation(annotation) {
    // currently unused
    return this.projectEditorOrItemOwner(annotation.createdBy);
  }

  canUpdateMessage(message) {
    // currently unused
    return this.projectEditorOrItemOwner(message.createdBy);
  }

  canDeleteAnnotation(annotation, creatorId) {
    /* Go server should provide this per annotation instead of mirroring here */
    return this.projectEditorOrItemOwner(annotation.createdBy || creatorId);
  }

  canDeleteMessage(message) {
    /* Go server should provide this per message instead of mirroring here */
    // console.log(message);
    return this.projectEditorOrItemOwner(message.createdBy);
  }
}
ModelRegistry.add(ProjectContextModel);

export class ProjectContextApp extends App {
  static registryName = 'ProjectContextApp';
  static Model = ProjectContextModel;
  static AppProps = {
    parentObj: 'ProjectApp',
  };
}
AppRegistry.add(ProjectContextApp);
